import script from "./DateBox.vue?vue&type=script&setup=true&lang=js"
export * from "./DateBox.vue?vue&type=script&setup=true&lang=js"

import "./DateBox.vue?vue&type=style&index=0&id=87b8477c&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87b8477c"]])

export default __exports__